import firebase from 'firebase';

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const gituhbProvider = new firebase.auth.GithubAuthProvider();